<script setup lang="ts">
import { IconAlert, IconRefresh } from '../Icons'
import Button from './Button.vue'

defineProps<{
  message: string
}>()

const emit = defineEmits<{ retry: [] }>()
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-3 px-6 py-12 text-center">
    <IconAlert :size="22" class="text-danger" />
    <p class="text-danger max-w-md text-[13px]">{{ message }}</p>
    <Button size="sm" @click="emit('retry')">
      <IconRefresh :size="13" />
      重试
    </Button>
  </div>
</template>
